import BanoImg from './images/banos.jpg'
import Bano2Img from './images/banos2.jpg'
import Bano3Img from './images/banos3.jpg'
import Bano4Img from './images/banos4.jpg'
import Bano5Img from './images/banos5.jpg'
import BbqImg from './images/bbq1.jpg'
import CasaRuralImg from './images/casa-rural.jpg'
import ChimeneaImg from './images/chimenea.jpg'
import Escalera1Img from './images/escalera-1.jpg'
import Escalera2Img from './images/escalera-2.jpg'
import Escalera3Img from './images/escalera-3.jpg'
import ExteriorImg from './images/exterior.jpg'
import FutbolinImg from './images/futbolin.jpg'
import Hab1_1Img from './images/hab1-1.jpg'
import Hab1_2Img from './images/hab1-2.jpg'
import Hab1_3Img from './images/hab1-3.jpg'
import Hab1_4Img from './images/hab1-4.jpg'
import Hab1_5Img from './images/hab1-5.jpg'
import Hab1_6Img from './images/hab1-6.jpg'
import Hab2_1Img from './images/hab2-1.jpg'
import Hab2_2Img from './images/hab2-2.jpg'
import Hab2_3Img from './images/hab2-3.jpg'
import Hab3_1Img from './images/hab3-1.jpg'
import Hab3_2Img from './images/hab3-2.jpg'
import Hab4_1Img from './images/hab4-1.jpg'
import Hab4_2Img from './images/hab4-2.jpg'
import Hab5_1Img from './images/hab5-1.jpg'
import Hab5_2Img from './images/hab5-2.jpg'
import Hab5_3Img from './images/hab5-3.jpg'
import PasilloInfImg from './images/pasillo-inf.jpg'
import PasilloInf2Img from './images/pasillo-inf2.jpg'
import PasilloInf3Img from './images/pasillo-inf3.jpg'
import PasilloSupImg from './images/pasillo-sup.jpg'
import PatioImg from './images/patio.jpg'
import PiscinaLeonImg from './images/piscina-leon.jpg'
import Piscina1Img from './images/piscina1.jpg'
import SalonButacasImg from './images/salon-butacas.jpg'
import SalonCocinaImg from './images/salon-cocina.jpg'
import SalonMesaImg from './images/salon-mesa.jpg'
import SalonTVImg from './images/salon-tv.jpg'
import SalonImg from './images/salon.jpg'
import Vistas1Img from './images/vistas1.jpg'
import Vistas2Img from './images/vistas2.jpg'

const imagenes = [
    {img: ExteriorImg, title: "Exterior"},
    {img: Piscina1Img, title: "Piscina"},
    {img: BbqImg, title: "Barbacoa"},
    {img: PiscinaLeonImg, title: "Piscina"},
    //{img: CasaRuralImg, title: "Casa Rural"},
    {img: SalonButacasImg, title: "Sala de estar"},
    {img: SalonCocinaImg, title: "Cocina"},
    {img: SalonMesaImg, title: "Mesa comedor"},
    {img: SalonTVImg, title: "Sala de estar"},
    {img: ChimeneaImg, title: "Chimenea"},
    {img: FutbolinImg, title: "Futbolín"},
    {img: Hab1_1Img, title: "Habitación 1"},
    {img: Hab1_2Img, title: "Habitación 1"},
    {img: Hab1_3Img, title: "Habitación 1"},
    {img: Hab1_4Img, title: "Habitación 1"},
    {img: Hab1_5Img, title: "Habitación 1"},
    {img: Hab1_6Img, title: "Habitación 1"},
    {img: BanoImg, title: "Baño"},
    {img: Hab2_1Img, title: "Habitación 2"},
    {img: Hab2_2Img, title: "Habitación 2"},
    {img: Hab2_3Img, title: "Habitación 2"},
    {img: Bano2Img, title: "Baño"},
    {img: Hab3_1Img, title: "Habitación 3"},
    {img: Hab3_2Img, title: "Habitación 3"},
    {img: Bano3Img, title: "Baño"},
    {img: Hab4_1Img, title: "Habitación 4"},
    {img: Hab4_2Img, title: "Habitación 4"},
    {img: Bano4Img, title: "Baño"},
    {img: Hab5_1Img, title: "Habitación 5"},
    {img: Hab5_2Img, title: "Habitación 5"},
    {img: Hab5_3Img, title: "Habitación 5"},
    {img: Bano5Img, title: "Baño"},
    {img: Escalera1Img, title: "Interiores"},
    {img: Escalera2Img, title: "Interiores"},
    {img: Escalera3Img, title: "Interiores"},
    {img: PasilloInfImg, title: "Interiores"},
    {img: PasilloInf2Img, title: "Interiores"},
    {img: PasilloInf3Img, title: "Interiores"},
    {img: PasilloSupImg, title: "Interiores"},
    {img: PatioImg, title: "Patio exterior"},
    {img: Vistas1Img, title: "Vistas"},
    {img: Vistas2Img, title: "Vistas"},
  ];

export default imagenes;


